import { stripeClient } from '@better-auth/stripe/client';
import { adminClient, organizationClient } from 'better-auth/client/plugins';
import { createAuthClient } from 'better-auth/react';

import { customAccessControls, roles } from '@/lib/access/roles';

export const authClient = createAuthClient({
  plugins: [
    adminClient(),
    stripeClient({
      subscription: true,
    }),
    organizationClient({
      ac: customAccessControls,
      roles,
    }),
  ],
});
